import { defineMessages } from 'react-intl';

import { NotIOsAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { SettingsSection } from '@sorare/core/src/components/settings/SettingsSection';

import { DepositCard as DepositCardButton } from '#src/components/wallet/DepositCard/index.tsx';

const messages = defineMessages({
  title: {
    defaultMessage: 'Deposit Card',
  },
  description: {
    defaultMessage:
      'Add Sorare Cards that are currently held in an external wallet.  This will allow you to use the Cards for Sorare fantasy games and list them on the marketplace.',
  },
});

export const DepositCard = () => {
  return (
    <NotIOsAppFeature exceptMarketAuthorizedIosApp>
      <SettingsSection {...messages}>
        <div>
          <DepositCardButton />
        </div>
      </SettingsSection>
    </NotIOsAppFeature>
  );
};
